// eslint-disable-next-line import/prefer-default-export
export enum ObalMaterialuEnum {
  VSEOBECNY = 'Všeobecný formulár obalu materiálu',
  NR_SR = 'Formulár obalu materiálu NR SR',
}
